import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProposalService } from 'src/app/services/proposal.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Proposal } from 'src/app/models/proposal';
import Helper from 'src/app/core/utility/helper';

@Component({
  selector: 'app-proposal-communication',
  templateUrl: './proposal-communication.component.html',
  styleUrls: ['./proposal-communication.component.scss']
})
export class ProposalCommunicationComponent implements OnInit {
  @Input() ProposalId: string;
  @Output() formReady: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  externalComments: FormGroup;
  proposalDTO: Proposal;
  rejectionInfo = [];
  rejectionComment = [];
  constructor(
    private proposalService: ProposalService,
    private fb: FormBuilder
  ) {
    this.externalComments = this.fb.group({
      ExternalComment: [null]
    });
  }

  ngOnInit() {
    this.proposalService.createProposalDTO.subscribe(x => {
      // If the proposal is updated with the proposalDTO get the information.
      if  (x) {
        this.proposalDTO = x.DefaultProposal;
        // Invoke Rejection Info function to set the required information display.
        if (this.proposalDTO.PackageInfo.RejectionReason && this.proposalDTO.PackageInfo.RejectionReason.length > 0) {
          this.rejectionInfo = Helper.fillRejectionInfo(this.proposalDTO);
      }
      this.rejectionComment = Helper.getListRejectionComment(this.proposalDTO.PackageInfo.RejectionComment);
      }
    });
    this.formReady.emit(this.externalComments);
  }
}
